// extracted by mini-css-extract-plugin
export default {"user-input-image-container":"SectionImage_user-input-image-container__GEPSw","section-image-wrapper":"SectionImage_section-image-wrapper__+UG0M"};